import React, { useState } from "react";
import BreadCrumb from "../common/BreadCrumb";

const Hero = ({ title, description }) => {
  const [expand, setExpand] = useState(false);
  return (
    <div className="flex flex-wrap mb-5 ml-[5px] 2xl:-ml-[10px]">
      <div className="w-full pb-[10px] md:pb-5 pl-[10px] md:pl-5">
        <BreadCrumb
          page="Shop"
          pageHandle="/collections"
          subPage={title}
          bg="white"
        />
      </div>
      <div className="w-full pb-[10px] md:pb-5 pl-[10px] md:pl-5">
        <h1 className="text-[25px] md:text-[62px] text-black font-bold">
          {title}
        </h1>
        {description && (
          <div className="whitespace-break-spaces w-full text-base font-medium tracking-wide text-primary-500 mt-3">
            <p
              className={`w-full ${
                expand ? "line-clamp-none" : "line-clamp-5 md:line-clamp-3"
              }`}
            >
              {description}
            </p>
            <div className="mt-5">
              {expand ? (
                <button
                  className="flex items-center outline-none"
                  onClick={() => setExpand(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="w-4 h-4"
                  >
                    <path d="M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" />
                  </svg>
                  <span className="ml-1">View Less</span>
                </button>
              ) : (
                <button
                  className="flex items-center outline-none"
                  onClick={() => setExpand(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="w-4 h-4"
                  >
                    <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                  </svg>
                  <span className="ml-1">View More</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
